function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-kuromu-2x-secret-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-kuromu-2x-secret-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F195F5",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C739DD",
  offset: "57.569%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C100D5",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-kuromu-2x-secret-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-kuromu-2x-secret-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-kuromu-2x-secret-b)",
  xlinkHref: "#avatar-kuromu-2x-secret-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#avatar-kuromu-2x-secret-c)",
  d: "M89 24.42v47.16C89 81.2 81.2 89 71.58 89H24.42c-7.54 0-13.974-4.818-16.392-11.536-.372-1.032.406-2.12 1.503-2.12H50.3c11.707 0 23.954-6.008 23.954-23.26V23.377c0-1.035-.837-1.873-1.872-1.873H32.835c-.776 0-1.405.614-1.443 1.39-.414 8.34-4.46 17.54-9.726 19.1-.92.27-1.562 1.102-1.562 2.062V47.9c0 2.107 1.98 3.643 4.026 3.136 6.512-1.615 13.836-7.274 14.855-19.752.046-.564.517-.998 1.083-.998h23.62c.602 0 1.09.487 1.09 1.088v20.093c0 9.396-5.777 15.404-17.254 15.404H8.94c-1.072 0-1.94-.866-1.94-1.937V24.42C7 14.8 14.8 7 24.42 7h47.16C81.2 7 89 14.8 89 24.42"
}));

var SvgKuromu = function SvgKuromu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKuromu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kuromu.3d49e1c3.svg";
export { ForwardRef as ReactComponent };